// import {html2canvas} from 'html2canvas'
const html2canvas = require('html2canvas');
import JsPDF from 'jspdf'
export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function () {
      var title = this.htmlTitle
      window.pageYOffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0;
      html2canvas(document.querySelector('#pdfDom'), {
        allowTaint: true,
        useCORS: true
      }).then(function (canvas) {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89
          let leftHeight = contentHeight
          let position = 0
          let imgWidth = 595.28
          let imgHeight = 592.28 / contentWidth * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
        // var oA = document.createElement("a");
        // oA.download = '';// 设置下载的文件名，默认是'下载'
        // oA.href = pageData;
        // document.body.appendChild(oA);
        // oA.click();
        // oA.remove(); // 下载之后把创建的元素删除
        //   return false;
          let PDF = new JsPDF('', 'pt', 'a4')
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(title + '.pdf')
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/pdf.js